__turbopack_context__.v({
  "centered": "Spinner-module-scss-module__ycR-aG__centered",
  "loader": "Spinner-module-scss-module__ycR-aG__loader",
  "loader__spinner": "Spinner-module-scss-module__ycR-aG__loader__spinner",
  "rotation": "Spinner-module-scss-module__ycR-aG__rotation",
});
